import { render } from "./BattlesGame.vue?vue&type=template&id=56f137ca&scoped=true"
import script from "./BattlesGame.vue?vue&type=script&lang=js"
export * from "./BattlesGame.vue?vue&type=script&lang=js"

import "./BattlesGame.vue?vue&type=style&index=0&id=56f137ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f137ca"]])

export default __exports__